export default __webpack_public_path__ + "static/media/fa-40px-3f3e3c.d5bebc7e.svg";